/**
 * Poster frame for a video optimized by scripts/migrate/4-optimize-media.js
 * (<name>-web.mp4 has a matching <name>-web-poster.webp). Returns undefined otherwise.
 */
export function getVideoPoster(videoUrl) {
  if (typeof videoUrl !== 'string') return undefined;
  const clean = videoUrl.split(/[?#]/)[0];
  return /-web\.mp4$/i.test(clean) ? clean.replace(/-web\.mp4$/i, '-web-poster.webp') : undefined;
}
